'use client';

import { Heading } from '@app/app/_components/Heading/Heading';
import { Select } from '@app/app/_components/Input/Select/Select';
import { InformationPopover } from '@app/app/_components/InformationPopover/InformationPopover';
import { QuestionCircleIcon } from '@app/app/_icons/QuestionCircleIcon';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseTransportInsuranceResult } from '@app/service/eshop/transport/actions/purchaseTransportInsurance';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

interface Props {
    ownerYear?: number;
    formState: FormState<PurchaseTransportInsuranceResult>;
}

export function DrivingExperiencePanel({ ownerYear, formState }: Props) {
    const t = useTranslations();

    const drivingExperienceError = formState.violations?.drivingExperience;

    const drivingExperienceOptions = useMemo(() => {
        if (!ownerYear) return [];

        const seniorityThreshold = ownerYear + 18;
        const currentYear = new Date().getFullYear();
        const options = [];

        for (let year = seniorityThreshold; year <= currentYear; year++) {
            options.push({
                label: year.toString(),
                value: year.toString(),
            });
        }
        return options;
    }, [ownerYear]);

    const initialDrivingExperience = formState.data?.formData.drivingExperience || '';

    return (
        <div className="flex flex-col gap-4 px-6">
            <div className="flex flex-row items-center gap-2">
                <Heading level="h3">{t('eshop.transport.drivingExperience')}</Heading>
                <InformationPopover content={t('eshop.transport.drivingExperienceTooltip')}>
                    <QuestionCircleIcon className="size-5 text-neutral-500" />
                </InformationPopover>
            </div>
            {drivingExperienceOptions.length > 0 && (
                <Select
                    searchable
                    options={drivingExperienceOptions}
                    name="drivingExperience"
                    placeholder={t('eshop.transport.drivingExperiencePlaceholder')}
                    defaultValue={initialDrivingExperience}
                    error={drivingExperienceError}
                />
            )}
        </div>
    );
}
